export type PerCornerRadius = {
  topLeft: number;
  topRight: number;
  bottomRight: number;
  bottomLeft: number;
};

export type BorderRadiusValue = number | PerCornerRadius;

export const isPerCorner = (value: unknown): value is PerCornerRadius =>
  typeof value === "object" &&
  value !== null &&
  typeof (value as PerCornerRadius).topLeft === "number" &&
  typeof (value as PerCornerRadius).topRight === "number" &&
  typeof (value as PerCornerRadius).bottomRight === "number" &&
  typeof (value as PerCornerRadius).bottomLeft === "number";

export const toUniform = (value: BorderRadiusValue): number => {
  if (typeof value === "number") return value;
  return Math.max(
    value.topLeft,
    value.topRight,
    value.bottomRight,
    value.bottomLeft
  );
};

export const toPerCorner = (value: BorderRadiusValue): PerCornerRadius => {
  if (isPerCorner(value)) return value;
  const n = typeof value === "number" ? value : 0;
  return { topLeft: n, topRight: n, bottomRight: n, bottomLeft: n };
};

export const toCssValue = (value: BorderRadiusValue): string => {
  if (isPerCorner(value)) {
    return `${value.topLeft}px ${value.topRight}px ${value.bottomRight}px ${value.bottomLeft}px`;
  }
  return `${typeof value === "number" ? value : 0}px`;
};

export const scaleBorderRadius = (
  value: BorderRadiusValue,
  scale: number
): BorderRadiusValue => {
  if (isPerCorner(value)) {
    return {
      topLeft: value.topLeft * scale,
      topRight: value.topRight * scale,
      bottomRight: value.bottomRight * scale,
      bottomLeft: value.bottomLeft * scale
    };
  }
  return (typeof value === "number" ? value : 0) * scale;
};
